(function (window, $) {
	var COMPONENT_NAME = 'ajaxSelect';

	window.app.register(COMPONENT_NAME, function ($element, options) {
		this.$input = $element;
		this.options = $.extend({}, this.$input.data('ajax-select'), options);
		this.init();
	}, {
		availableCommands: [
			'destroy', 'getInput', 'val'
		],

		init: function() {
			var self = this;
			$.fn.select2.defaults.set('language', 'cs');
			this.$input.select2({
				width: this.options.width || "element",
				dropdownParent: this.options.dropdownParent || $(document.body),
				formatSearching: function() {
					return window.app.text.ajaxSelect.searching ? window.app.text.ajaxSelect.searching : "Searching...";
				},
				// language: window.hasOwnProperty('select2translations') ? window.select2translations() : {},
				placeholder: this.options.prompt || undefined,
				allowClear: this.options.prompt ? true : false,
				minimumInputLength: self.$input.is('.no-minimum-input-requirement') ? 0 : 2,
				theme: 'bootstrap-5',
				language: 'cs',
				ajax: {
					url: this.options.url,
					dataType: 'json',
					delay: 250,
					data: function (term, page) {

						var options = $.extend({ }, self.options.entityOptions);
						options[self.options.queryParam] = term.term;

						// zavolat callback ktery dostane options a vrátí options
						if (self.options.redefineOptions) {
							options = self.options.redefineOptions(options);
						}

						return {
							entityName: self.options.entityName,
							entityOptions: options,
						};
					},
					processResults: function (data, page, s2) {
						if (data.redirect !== undefined) {
							window.location.href = data.redirect;
							return false;
						}

						if (self.options.redefineResultData) {
							data = self.options.redefineResultData(data);
						}

						return { results: data };
					},
					cache: true
				},
			});
		},

		val: function(id, text) {
			if (id !== null && typeof id === 'object') {
				text = id.text;
				id = id.id;
			}

			var option = new Option(text, id);
			option.selected = true;
			this.$input.append(option);
			this.$input.trigger('change');
		},

		getInput: function() {
			return this.$input;
		},

		destroy: function() {
			this.$input.select2('destroy');
			window.app.unbindComponentFromElement(this.$input, COMPONENT_NAME);

			return this.$input;
		},

	});
}(window, jQuery));